/**
 * Vip Level Replacer View
 */

define(function(require, exports, module) {
    'use strict';
    var BaseReplacerView = require('common/base.replacer.view'),
        VipLevelModel = require('replacers/vip-level/vip-level.model'),
        user = require('user');

    module.exports = BaseReplacerView.extend({

        tagName: 'span',

        className: 'vip-level',

        accessRules: {
            allow: ['user']
        },

        initialize: function(options) { // eslint-disable-line
            BaseReplacerView.prototype.initialize.apply(this, arguments);
            this.model = new VipLevelModel();
        },

        render: function() {
            this.model.fetch()
                .done(function() {
                    const loyaltyLevel = user.get('userDetails').vipLevel;

                    this.$el.html(this.translate('playtech.mobile.system.balance.vip-level.VIP' + loyaltyLevel));
                }.bind(this));
            return this;
        },

        close: function() {
            BaseReplacerView.prototype.close.call(this);

            this.model && this.model.clear();
        }
    }, {
        nameOfReplacers: [
            'CASINO_LOYALTY_LEVEL'
        ]
    });
});
